import { useState, useContext } from "react";
import { Link } from "react-router-dom";

import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";

import { Divider } from "antd";

// Authentication layout components
import SignInLayout from "layouts/upstyled/SigninLayout";

import { AccountContext } from "context/account";
import { StoreContext } from "context/store";
import CategoryContext from "context/category-context";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import ResetTokenCard from "components/UpStyled/ResetTokenCard";
import VerifyEmailCard from "pages/signin/VerifyEmailCard";
//import LetterLogo from "components/UpStyled/LetterLogo";
import UpStyledLogo from "components/UpStyled/UpStyledLogo";
import toast from "react-hot-toast";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";

import api from "services/api";
import qs from "query-string";
import axios from "axios";

function SignIn() {
  const [resetPassword, setResetPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [verifyEmail, setVerifyEmail] = useState("");
  const [createAccountData, setCreateAccountData] = useState(null);

  const account = useContext(AccountContext);
  const store = useContext(StoreContext);
  const {
    actions: { refreshCategoryTree },
  } = useContext(CategoryContext);

  let navigate = useNavigate();
  const location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);

  const { handleSubmit, register, getValues } = useForm();

  const afterAuth = async (user, type = "signin") => {
    try {
      await store.retriveStore();
      const login_times = user?.metadata?.login_times || 0;
      await account.handleUpdate(user.id, {
        metadata: {
          ...user.metadata,
          login_times: login_times + 1,
          login_type: type,
          login_date: new Date(),
        },
      });

      if (urlObj?.query.hostname == window?.location?.hostname) {
        navigate(urlObj?.query.pathname, { replace: true });
      } else {
        if (user.account_type == "de") {
          navigate("/dashboard", { replace: true });
        } else if (user.account_type == "ma") {
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/wall/portfolio", { replace: true });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleLogin = async (data) => {
    try {
      const { user } = await account.handleLogin({ email: data.email, password: data.password });
      afterAuth(user);
    } catch (err) {
      let message = "These credentials do not match our records!";
      if (err?.response?.data?.error_code == -2) {
        //inactive account
        setVerifyEmail(data.email);
        message = (
          <div>
            <p>Account is not active!</p>
            <p>Please check your verification email to active the account!</p>
          </div>
        );
      }
      setErrorMessage(message);
    }
  };

  const googlelogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (codeResponse) => {
      try {
        const { data } = await api.auth.google({ code: codeResponse.code });

        const user = await api.auth.googleAuth({
          access_token: data.access_token,
        });

        if (user?.data?.user) {
          //successfully
          toast.success("Successfully Log In!");
          afterAuth(user?.data?.user, "google-auth");
        } else {
          console.log("user not existed, create the user and auth", user);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to finish google auth!");
      }
    },
    onError: (errorResponse) => {
      toast.error("Failed to finish google auth!");
      console.log(errorResponse);
    },
  });

  return (
    <SignInLayout>
      <div className="flex h-full w-full items-center justify-center">
        <div className="flex min-h-[400px] bg-white rounded-lg shadow-lg justify-center">
          <div className="flex flex-col pt-8 w-full px-[80px] items-center mb-8">
            {resetPassword ? (
              <ResetTokenCard goBack={() => setResetPassword(false)} />
            ) : verifyEmail ? (
              <VerifyEmailCard goBack={() => setVerifyEmail("")} email={verifyEmail} />
            ) : (
              <form
                onSubmit={handleSubmit(handleLogin)}
                className="flex flex-col w-full items-center"
              >
                <SuiBox mb={1} px={6} display="flex" justifyContent="center" sx={{ width: "100%" }}>
                  <div>
                    <UpStyledLogo sx={{ height: 80 }} />
                  </div>
                </SuiBox>
                <span className="inter-base-regular text-gray-500 my-1 text-xl">Studio Portal</span>
                <span className="inter-base-regular text-gray-500  text-base">
                  Log in to your account
                </span>

                <SuiButton
                  variant="outlined"
                  color="dark"
                  size="small"
                  onClick={() => googlelogin()}
                  sx={{ textTransform: "none", width: "100%", mt: 2, fontSize: 14 }}
                >
                  <svg width="24px" height="24px" viewBox="0 0 64 64" version="1.1">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g transform="translate(3.000000, 2.000000)" fillRule="nonzero">
                        <path
                          d="M57.8123233,30.1515267 C57.8123233,27.7263183 57.6155321,25.9565533 57.1896408,24.1212666 L29.4960833,24.1212666 L29.4960833,35.0674653 L45.7515771,35.0674653 C45.4239683,37.7877475 43.6542033,41.8844383 39.7213169,44.6372555 L39.6661883,45.0037254 L48.4223791,51.7870338 L49.0290201,51.8475849 C54.6004021,46.7020943 57.8123233,39.1313952 57.8123233,30.1515267"
                          fill="#4285F4"
                        />
                        <path
                          d="M29.4960833,58.9921667 C37.4599129,58.9921667 44.1456164,56.3701671 49.0290201,51.8475849 L39.7213169,44.6372555 C37.2305867,46.3742596 33.887622,47.5868638 29.4960833,47.5868638 C21.6960582,47.5868638 15.0758763,42.4415991 12.7159637,35.3297782 L12.3700541,35.3591501 L3.26524241,42.4054492 L3.14617358,42.736447 C7.9965904,52.3717589 17.959737,58.9921667 29.4960833,58.9921667"
                          fill="#34A853"
                        />
                        <path
                          d="M12.7159637,35.3297782 C12.0932812,33.4944915 11.7329116,31.5279353 11.7329116,29.4960833 C11.7329116,27.4640054 12.0932812,25.4976752 12.6832029,23.6623884 L12.6667095,23.2715173 L3.44779955,16.1120237 L3.14617358,16.2554937 C1.14708246,20.2539019 0,24.7439491 0,29.4960833 C0,34.2482175 1.14708246,38.7380388 3.14617358,42.736447 L12.7159637,35.3297782"
                          fill="#FBBC05"
                        />
                        <path
                          d="M29.4960833,11.4050769 C35.0347044,11.4050769 38.7707997,13.7975244 40.9011602,15.7968415 L49.2255853,7.66898166 C44.1130815,2.91684746 37.4599129,0 29.4960833,0 C17.959737,0 7.9965904,6.62018183 3.14617358,16.2554937 L12.6832029,23.6623884 C15.0758763,16.5505675 21.6960582,11.4050769 29.4960833,11.4050769"
                          fill="#EB4335"
                        />
                      </g>
                    </g>
                  </svg>
                  <span style={{ marginLeft: 2 }}>Sign in with Google</span>
                </SuiButton>

                <Divider>
                  <SuiTypography variant="button" fontWeight="medium" color="secondary">
                    or
                  </SuiTypography>
                </Divider>

                <SuiBox mb={1} lineHeight={1.25} sx={{ width: "100%" }}>
                  <SuiBox mb={1} ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Email
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput
                    type="email"
                    placeholder="Email"
                    required
                    {...register("email", { required: true })}
                  />
                </SuiBox>

                <SuiBox mb={1} lineHeight={1.25} sx={{ width: "100%" }}>
                  <SuiBox mb={1} ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Password
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput
                    type="password"
                    placeholder="Password"
                    required
                    {...register("password", { required: true })}
                  />
                </SuiBox>

                {errorMessage ? (
                  <span className="text-rose-500 max-w-[400px] mt-1 inter-small-regular">
                    {errorMessage}
                  </span>
                ) : (
                  <div className="mt-1" />
                )}

                <SuiButton
                  variant="gradient"
                  color="dark"
                  fullWidth
                  type="submit"
                  className="mt-2 mb-1"
                >
                  sign in
                </SuiButton>
                <SuiBox
                  textAlign="center"
                  display="flex"
                  justifyContent="space-between"
                  sx={{ width: "100%", height: "" }}
                >
                  <div></div>
                  <SuiTypography
                    variant="button"
                    color="text"
                    fontWeight="regular"
                    onClick={() => setResetPassword(true)}
                    className="cursor-pointer"
                  >
                    Reset Password
                  </SuiTypography>
                </SuiBox>
              </form>
            )}
            <SuiBox mt={1} textAlign="center">
              <SuiTypography variant="button" color="text" fontWeight="regular">
                Don&apos;t have an account?{" "}
                <SuiTypography
                  component={Link}
                  to="/register"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </SuiTypography>
              </SuiTypography>
            </SuiBox>
          </div>
        </div>
      </div>
    </SignInLayout>
  );
}

export default SignIn;
